import React, { useState, useEffect } from "react";
import { isAdmin, isMaster } from "../../../utils/checkPermission";
import { useLanguage, useSite } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import { useAuth } from "../../../hooks";
import { GeneralDashboard } from "../../../components/Admin/Dashboard/GeneralDashboard";
import "./Dashboard.scss";

export function DashboardGeneral() {
  const { translations } = useLanguage();
  const { user: { role } } = useAuth();
  const t = (key) => translations[key] || key;

  const [siteSelected, setSiteSelected] = useState(null);
  const [companySelected, setCompanySelected] = useState(null);

  const { site } = useSite();
  const { company } = useCompany();

  const needsWelcome = !company || company === "" || company === "0";

  useEffect(() => {
    setCompanySelected(company);
  }, [company]);

  useEffect(() => {
    setSiteSelected(site);
  }, [site]);

  if (!(isMaster(role) || isAdmin(role))) {
    return (
      <div className="welcome-selector">
        <div className="welcome-selector__card">
          <h1 className="welcome-selector__title">{t("WELCOME")}</h1>
        </div>
      </div>
    );
  }

  if (needsWelcome) {
    return (
      <div className="welcome-selector">
        <div className="welcome-selector__card">
          <h1 className="welcome-selector__title">{t("WELCOME")}</h1>
          <p className="welcome-selector__subtitle">{t("welcome_dashboard_subtitle")}</p>
        </div>
      </div>
    );
  }

  return <GeneralDashboard site={siteSelected} company={companySelected} />;
}
